// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgAddMember24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.13636 4.25C11.3581 4.25 13.1591 6.05104 13.1591 8.27273C13.1591 10.4944 11.3581 12.2955 9.13636 12.2955C6.91467 12.2955 5.11364 10.4944 5.11364 8.27273C5.11364 6.05104 6.91467 4.25 9.13636 4.25ZM9.13636 5.75C7.7431 5.75 6.61364 6.87946 6.61364 8.27273C6.61364 9.66599 7.7431 10.7955 9.13636 10.7955C10.5296 10.7955 11.6591 9.66599 11.6591 8.27273C11.6591 6.87946 10.5296 5.75 9.13636 5.75ZM12 13.25C14.2217 13.25 16.0227 15.051 16.0227 17.2727V18.9091C16.0227 19.3233 15.6869 19.6591 15.2727 19.6591H3C2.58579 19.6591 2.25 19.3233 2.25 18.9091V17.2727C2.25 15.051 4.05104 13.25 6.27273 13.25H12ZM12.1659 14.7554L12 14.75H6.27273C4.87946 14.75 3.75 15.8795 3.75 17.2727V18.159H14.522L14.5227 17.2727C14.5227 15.9352 13.4818 14.8408 12.1659 14.7554ZM18.5455 8.34091C18.9597 8.34091 19.2955 8.6767 19.2955 9.09091V10.7955H21C21.4142 10.7955 21.75 11.1312 21.75 11.5455C21.75 11.9597 21.4142 12.2955 21 12.2955H19.2955V14C19.2955 14.4142 18.9597 14.75 18.5455 14.75C18.1312 14.75 17.7955 14.4142 17.7955 14V12.2955H16.0909C15.6767 12.2955 15.3409 11.9597 15.3409 11.5455C15.3409 11.1312 15.6767 10.7955 16.0909 10.7955H17.7955V9.09091C17.7955 8.6767 18.1312 8.34091 18.5455 8.34091Z"
				/>
			</Svg>
		);
	}
);
SvgAddMember24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgAddMember24;
